import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { GetAgencyBO } from './agency.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';

@Injectable({ providedIn: 'root' })

export class GetHTTPServiceAgency extends Subject<DataStateChangeEventArgs>{

  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent, public general: GeneralService, private ngxService: NgxUiLoaderService) {
    super();
  }

  public execute(state: GetAgencyBO): void {
    this.getAgencyList(state).subscribe(x => super.next(x));
    this.ngxService.stop()
  }

  getAgencyList(state?: GetAgencyBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Agency/GetAgencies", state)
      .pipe(map(
        (response: any) =>
        (<any>{
          result: response['result'],
          count: response['count']
        }
        ))).pipe(map((e: any) => {
          e.result.forEach(element => {
            element.phone = element.phone != null ? this.general.reconverPhoneGoogleLibhttpsave(element.phone) : null;
            element.fax = element.fax != null ? this.general.reconverPhoneGoogleLibhttpsave(element.fax) : null;
          })
          return e;
        })
        )
  }

}
